export default __webpack_public_path__ + "static/media/placeholder.31a3f520.png";